import { render, staticRenderFns } from "./batch-management.vue?vue&type=template&id=e4a03b30&scoped=true&"
import script from "./batch-management.vue?vue&type=script&lang=js&"
export * from "./batch-management.vue?vue&type=script&lang=js&"
import style0 from "./batch-management.vue?vue&type=style&index=0&id=e4a03b30&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4a03b30",
  null
  
)

export default component.exports